<h5 class="modal-title">Modal title</h5>
<button type="button" class="close" data-dismiss="modal" aria-label="Close">
	<i class="fn-global-times"></i>
</button>
